import { createContext } from "react"

export type CardImageFiles = {
  /** Session files this message already shows as generated-image cards. */
  files: ReadonlySet<string>
  /** The chat session the files belong to; only its session-content paths match. */
  sessionId?: string
}

/**
 * Read through context rather than the markdown renderer config: StableBlock
 * re-renders only when that config's identity changes, and changing it would
 * remount every frozen block (#3473).
 */
export const CardImageFilesContext = createContext<CardImageFiles>({ files: new Set() })
